var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('a-card',[_c('p',{attrs:{"slot":"title"},slot:"title"},[_c('span',[_vm._v(_vm._s(_vm.$t('流程图'))+" ")])]),(_vm.svgShow)?_c('div',{style:({height: _vm.svgHeight})},[_c('bpmnModeler',{ref:"bpm",staticClass:"svg",attrs:{"xml":_vm.xmlData,"is-view":true}})],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }